import { all, put, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { REQUEST_LEADS_OVERVIEW } from './types';

import { leadsOverviewSuccess, leadsOverviewFailure } from './reducer';

const logger = new Logger('Saga:Dashboard:LeadsOverview');

export function* getLeadsOverview() {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield authApiService.get(
      routerService.generate('api.dashboard.leads_overview'),
    );

    logger.info('Got leads overview data');
    yield put(leadsOverviewSuccess(response.data));
  } catch (error) {
    logger.error(error);
    yield put(leadsOverviewFailure(error));
  }
}

export default function* leadsOverviewSaga() {
  return yield all([takeLatest(REQUEST_LEADS_OVERVIEW, getLeadsOverview)]);
}
